import { FileText, Mail, MessageCircle, MessageSquare, Phone, UserRound, Video, type LucideIcon } from "lucide-react";
import type { ContactChannel } from "./client";

/** Each channel's icon, wherever a contact is shown: the profile's history and the contact log. */
export const CHANNEL_ICON: Record<ContactChannel, LucideIcon> = {
    call: Phone,
    text: MessageSquare,
    virtual: Video,
    email: Mail,
    letter: FileText,
    inPerson: UserRound,
    chat: MessageCircle,
};

export const CHANNEL_TONE: Record<ContactChannel, string> = {
    call: "bg-channel-call/10 text-channel-call",
    text: "bg-channel-text/10 text-channel-text",
    virtual: "bg-channel-virtual/10 text-channel-virtual",
    email: "bg-channel-email/10 text-channel-email",
    letter: "bg-channel-letter/10 text-channel-letter",
    inPerson: "bg-channel-in-person/10 text-channel-in-person",
    chat: "bg-channel-chat/10 text-channel-chat",
};
